import { render, staticRenderFns } from "./InitialSetup.vue?vue&type=template&id=d7a437a0&scoped=true"
import script from "./InitialSetup.vue?vue&type=script&lang=js"
export * from "./InitialSetup.vue?vue&type=script&lang=js"
import style0 from "./InitialSetup.vue?vue&type=style&index=0&id=d7a437a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a437a0",
  null
  
)

export default component.exports